import { gql } from "@apollo/client";

export const CREATE_COURSE_MOMENT = gql`
  mutation CreateCourseMoment($input: UpdateCourseMomentInput!) {
    createCertCourseMoment(input: $input) {
      id
      title
    }
  }
`;

export const UPDATE_COURSE_MOMENT = gql`
  mutation UpdateCourseMoment($id: ID!, $input: UpdateCourseMomentInput!) {
    updateCertCourseMoment(id: $id, input: $input) {
      id
      title
    }
  }
`;

export const DELETE_COURSE_MOMENT = gql`
  mutation DeleteCourseMoment($id: ID!) {
    deleteCertCourseMoment(id: $id) {
      id
    }
  }
`;
